export * from './replace.directive';



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/directives/replace/index.ts